export default {
  // Tabs
  loginIpSummary: "Login IP Summary",
  loginIpDetails: "Login IP Details",
  deviceDetails: "Device Details",

  // Search
  ipLocationPlaceholder: "Enter IP Location",
  reset: "Reset",
  query: "Query",

  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns - Login IP Summary/Details
  ipAddress: "IP Address",
  ipLocation: "IP Location",
  loginCount: "Login Count",
  recentLoginTime: "Recent Login Time",
  loginTime: "Login Time",
  loginMethod: "Login Method",
  port: "Port",

  // Table columns - Device Details
  deviceName: "Device Name",
  deviceId: "Device ID (UUID)",
  client: "Client",
  imei: "IMEI",
  mac: "MAC",

  // Empty state
  noIpData: "No IP data parsed from current investigation file",
  noDeviceData: "No login device data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",
};
